<div class="screen">
  <div class="screen-inner">
    @if (broadcast) {
      <header class="topbar">
        <span></span>
        <h1 class="topbar-title">{{ headline() }}</h1>
        <span></span>
      </header>
    } @else {
      <app-shell nav="back" action="menu" [title]="headline()" [backTo]="backTo()"></app-shell>
    }

    @if (board) {
      <p class="section-label">{{ subtitle() }}</p>

      @if (board.rows.length === 0) {
        <p class="page-note">No scores yet.</p>
      } @else {
        <div class="card">
          @for (row of board.rows; track row.name) {
            <div class="lb-row" [class.row-highlight]="isMe(row)">
              <span class="lb-rank">{{ row.rank }}</span>
              <span class="lb-name">
                {{ row.name }}
                @if (board.usesRunningTee && row.currentTeeName) {
                  <span class="lb-tee">{{ row.currentTeeName }}</span>
                }
              </span>
              <span class="lb-topar">{{ toPar(row.toPar) }}</span>
              <span class="lb-hole" [class.lb-time]="row.lastHole == null && !!row.teeTime">{{ holeLabel(row) }}</span>
            </div>
          }
        </div>
      }

      @if (!broadcast && board.firstRoundId) {
        <a class="btn-primary" [routerLink]="['/events', eventId, 'score', board.firstRoundId]">Enter my score</a>
        <a class="btn-secondary btn-block" [routerLink]="['/events', eventId, 'score', board.firstRoundId, 'card']">Scorecard</a>
      }
    }

    @if (error) { <p class="error">{{ error }}</p> }
  </div>
</div>
